import {Button, styled} from '@mui/material';

const StyledButton = styled(Button)`
	width: 330px;
	margin-left: auto;

	${({theme}) => theme.breakpoints.down('sm')} {
		width: 100%;
	}
`;

export {StyledButton};
